<ng-template
  let-extraClass="extraClass"
  #topNav
  />

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <ng-container>

      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }

      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              [label]="'First Name *'"
              formControlName="firstName"
              [form]="form.controls.firstName"
              [icon]="'assets/svg/person-circle.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter Client\'s first name'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              [label]="'Last Name *'"
              formControlName="lastName"
              [form]="form.controls.lastName"
              [icon]="'assets/svg/person-circle.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter Client\'s last name'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'Email *'"
              formControlName="email"
              type="email"
              [form]="form.controls.email"
              [icon]="'assets/svg/mail.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid email'" />
          </tidy-row>
        </form>
      </tidy-card>

      <ng-container *ngTemplateOutlet="noAddressPickedTemplate" />

      <tidy-row>
        <tidy-button
          [text]="(editingEmployee ? ('Edit' | translate) : ('Add' | translate)) + (' Employee' | translate)"
          [action]="boundConfirm"
          class="primary" />
      </tidy-row>

    </ng-container>
  </tidy-wrapper>
</ng-template>

<ion-content class="ion-content-right-column">
  <ng-container *ngTemplateOutlet="content" />
</ion-content>
